// extracted by mini-css-extract-plugin
module.exports = {"splitConent":"splitConent_splitConent__2j4ca"};